module.exports = __webpack_public_path__ + "static/media/comentarios_hp_01.a9d49edd.jpg";